const popularRoutes = [
  { label: "Delhi -> Jaipur", price: "INR 2,999", slug: "/delhi-jaipur" },
  { label: "Mumbai -> Pune", price: "INR 2,499", slug: "/mumbai-pune" },
  { label: "Bangalore -> Mysore", price: "INR 3,299", slug: "/bangalore-mysore" },
  { label: "Chennai -> Pondy", price: "INR 4,299", slug: "/chennai-pondy" },
  { label: "Kolkata -> Digha", price: "INR 3,999", slug: "/kolkata-digha" },
  { label: "Hyderabad -> Vizag", price: "INR 5,299", slug: "/hyderabad-vizag" }
];

const BASE_KEYWORDS =
  "taxi service, cab booking, airport taxi, outstation cabs, corporate travel, wedding fleet";

const STATIC_PAGES = {
  cabServices: {
    path: "/cab-services",
    seo: {
      title: "Cab Services in Chennai | BookinIndia Taxi Solutions",
      description:
        "Explore BookinIndia cab services in Chennai including airport taxi, outstation cabs, hourly rentals, corporate travel, wedding fleet, and event transfers.",
      keywords: `${BASE_KEYWORDS}, chennai cab services, chennai taxi booking`,
      canonicalUrl: "/cab-services"
    },
    hero: {
      title: "Cab Services Built for Every Journey",
      subtitle:
        "From airport pickups to corporate travel, BookinIndia delivers safe, on-time taxi services across Chennai."
    },
    intro:
      "BookinIndia offers flexible cab services designed for daily commutes, special events, and long-distance travel. Choose a ride that fits your schedule and budget with transparent pricing.",
    highlights: [
      {
        title: "24/7 Availability",
        text: "Book rides anytime in Chennai with quick confirmation."
      },
      {
        title: "Verified Drivers",
        text: "Professionally trained drivers with verified documents."
      },
      {
        title: "Transparent Pricing",
        text: "No hidden fees, clear fare estimates before booking."
      }
    ],
    sections: [
      {
        title: "Popular Cab Services",
        text:
          "Airport taxi, outstation cabs, hourly rentals, corporate travel, wedding fleet, and event transfers."
      },
      {
        title: "Why Chennai Chooses BookinIndia",
        text:
          "Clean vehicles, reliable pickups, and support you can reach anytime."
      }
    ],
    routes: popularRoutes,
    cta: {
      title: "Ready to Book Your Cab?",
      text:
        "Get a safe and comfortable ride in minutes with BookinIndia’s Chennai taxi service.",
      button: "Book Now",
      link: "/vehicle-selection"
    }
  },
  airportTaxi: {
    path: "/airport",
    seo: {
      title: "Chennai Airport Taxi | 24/7 Pickup & Drop",
      description:
        "Book Chennai Airport taxi with BookinIndia for reliable pickups and drops. Clean cabs, on-time service, and fair pricing.",
      keywords:
        "chennai airport taxi, airport cab chennai, MAA airport taxi, airport pickup",
      canonicalUrl: "/airport"
    },
    hero: {
      title: "Chennai Airport Taxi That’s Always On Time",
      subtitle:
        "Fast pickups, professional drivers, and smooth airport transfers at any hour."
    },
    intro:
      "Avoid last-minute stress with BookinIndia’s airport taxi service in Chennai. We track your timing, arrive early, and ensure comfortable rides to or from MAA.",
    sections: [
      {
        title: "Airport Pickup and Drop",
        text:
          "We serve both arrivals and departures with timely scheduling and verified drivers."
      },
      {
        title: "Fixed Fare Transparency",
        text:
          "Know your fare before you ride with clear price estimates."
      }
    ],
    cta: {
      title: "Book Your Airport Taxi",
      text: "Reserve your Chennai airport cab now and travel worry-free.",
      button: "Book Airport Taxi",
      link: "/chennai-airport-taxi"
    }
  },
  outstationCabs: {
    path: "/outstation",
    seo: {
      title: "Outstation Cabs from Chennai | One-Way & Round Trips",
      description:
        "Book outstation taxis from Chennai with BookinIndia. Comfortable cabs, transparent fares, and flexible travel options.",
      keywords:
        "outstation cabs chennai, chennai outstation taxi, one way cab chennai",
      canonicalUrl: "/outstation"
    },
    hero: {
      title: "Outstation Cabs from Chennai",
      subtitle:
        "Travel longer routes comfortably with verified drivers and fair pricing."
    },
    intro:
      "Plan your outstation journey with BookinIndia and enjoy clean AC cabs, flexible stops, and safe travel across South India.",
    sections: [
      {
        title: "One-Way & Round Trips",
        text:
          "Choose the plan that suits you, with transparent pricing and no surprises."
      },
      {
        title: "Long-Distance Comfort",
        text:
          "Spacious vehicles and experienced drivers make long rides easy."
      }
    ],
    routes: popularRoutes,
    cta: {
      title: "Plan Your Outstation Ride",
      text: "Book a reliable outstation cab in minutes.",
      button: "Start Booking",
      link: "/vehicle-selection"
    }
  },
  hourlyRentals: {
    path: "/hourly",
    seo: {
      title: "Hourly Taxi Rentals in Chennai | Flexible City Rides",
      description:
        "Book hourly taxi rentals in Chennai with BookinIndia. Ideal for shopping, meetings, and local city travel.",
      keywords:
        "hourly taxi rental chennai, cab on rent chennai, local taxi chennai",
      canonicalUrl: "/hourly"
    },
    hero: {
      title: "Hourly Rentals for Chennai City Travel",
      subtitle:
        "Keep a cab with you for multiple stops, meetings, or errands."
    },
    intro:
      "Hourly rentals are perfect for business trips, shopping days, or multi-stop travel within Chennai.",
    sections: [
      {
        title: "Flexible Timings",
        text:
          "Book by the hour and move around Chennai without booking a new cab each time."
      },
      {
        title: "Transparent Packages",
        text:
          "Clear hourly pricing with zero hidden charges."
      }
    ],
    cta: {
      title: "Need a Cab by the Hour?",
      text: "Book a taxi rental for smooth city travel.",
      button: "Book Hourly",
      link: "/vehicle-selection"
    }
  },
  corporateTravel: {
    path: "/corporate",
    seo: {
      title: "Corporate Taxi Services Chennai | Business Travel Solutions",
      description:
        "Book corporate taxi services in Chennai with BookinIndia. Reliable business travel, professional drivers, and clean vehicles.",
      keywords:
        "corporate taxi chennai, business travel cab, corporate travel services",
      canonicalUrl: "/corporate"
    },
    hero: {
      title: "Corporate Travel Made Reliable",
      subtitle:
        "Professional cabs for office travel, client pickups, and executive rides."
    },
    intro:
      "BookinIndia provides corporate travel solutions in Chennai with priority support, verified drivers, and clean vehicles.",
    sections: [
      {
        title: "Executive-Ready Fleet",
        text:
          "Sedans and premium cars with professional, uniformed drivers."
      },
      {
        title: "Invoice-Friendly Booking",
        text:
          "Easy tracking and quick billing for corporate travel needs."
      }
    ],
    cta: {
      title: "Book Corporate Travel",
      text: "Make your business travel smooth and predictable.",
      button: "Request Corporate Cab",
      link: "/contact-details"
    }
  },
  weddingFleet: {
    path: "/wedding",
    seo: {
      title: "Wedding Car Rentals Chennai | Premium Fleet for Events",
      description:
        "Reserve a wedding fleet in Chennai with BookinIndia. Elegant cars, punctual drivers, and stress-free event coordination.",
      keywords:
        "wedding car rentals chennai, wedding fleet, luxury wedding taxi",
      canonicalUrl: "/wedding"
    },
    hero: {
      title: "Wedding Fleet for Chennai Celebrations",
      subtitle:
        "Elegant vehicles and reliable drivers for your special day."
    },
    intro:
      "BookinIndia offers a premium fleet for weddings and special occasions in Chennai, ensuring timely arrivals and seamless coordination.",
    sections: [
      {
        title: "Elegant Fleet Options",
        text:
          "Choose from premium sedans and spacious SUVs for wedding travel."
      },
      {
        title: "Event Coordination Support",
        text:
          "We help coordinate pickup and drop schedules for guests."
      }
    ],
    cta: {
      title: "Reserve Your Wedding Fleet",
      text: "Secure reliable wedding transport in Chennai today.",
      button: "Enquire Now",
      link: "/contact"
    }
  },
  eventTransfers: {
    path: "/events",
    seo: {
      title: "Event Transfers Chennai | Reliable Cab Services",
      description:
        "Book event transfers in Chennai with BookinIndia. Reliable cabs for conferences, concerts, and large gatherings.",
      keywords:
        "event transfers chennai, event taxi service, group travel cabs",
      canonicalUrl: "/events"
    },
    hero: {
      title: "Event Transfers with Confidence",
      subtitle:
        "Reliable cabs for conferences, concerts, and group gatherings."
    },
    intro:
      "Ensure timely arrivals for your guests with BookinIndia’s event transfer services in Chennai.",
    sections: [
      {
        title: "Group Transfer Planning",
        text:
          "Coordinate multiple pickups and drops with a single booking partner."
      },
      {
        title: "Trusted Drivers",
        text:
          "All drivers are verified and trained for event-day professionalism."
      }
    ],
    cta: {
      title: "Plan Event Transport",
      text: "Get assistance with event taxi logistics.",
      button: "Contact Us",
      link: "/contact"
    }
  },
  popularRoutes: {
    path: "/popular-routes",
    seo: {
      title: "Popular Taxi Routes | BookinIndia",
      description:
        "Browse popular taxi routes with BookinIndia. Transparent fares and comfortable rides across major cities.",
      keywords: "popular taxi routes, intercity cab booking, outstation cabs",
      canonicalUrl: "/popular-routes"
    },
    hero: {
      title: "Popular Taxi Routes Across India",
      subtitle:
        "Discover the most booked intercity routes with starting fares."
    },
    intro:
      "BookinIndia makes intercity travel easy with verified drivers, clean vehicles, and predictable pricing.",
    sections: [
      {
        title: "Why Travelers Choose Us",
        text:
          "Trusted service, reliable timings, and comfort on every route."
      }
    ],
    routes: popularRoutes,
    cta: {
      title: "Need a Custom Route?",
      text: "Tell us your pickup and drop location for a quick quote.",
      button: "Request a Quote",
      link: "/contact"
    }
  },
  delhiJaipur: {
    path: "/delhi-jaipur",
    seo: {
      title: "Delhi to Jaipur Taxi | Safe Outstation Cabs",
      description:
        "Book a Delhi to Jaipur taxi with BookinIndia. Clean cabs, professional drivers, and transparent pricing.",
      keywords: "delhi to jaipur taxi, jaipur cab booking, outstation cab delhi",
      canonicalUrl: "/delhi-jaipur"
    },
    hero: {
      title: "Delhi to Jaipur Taxi Service",
      subtitle: "Comfortable outstation cabs with clear pricing."
    },
    intro:
      "Travel between Delhi and Jaipur with reliable drivers and clean vehicles. Flexible one-way and round-trip options available.",
    sections: [
      {
        title: "Reliable Outstation Rides",
        text:
          "Book a smooth ride with verified drivers and spacious cars."
      }
    ],
    cta: {
      title: "Book Delhi -> Jaipur",
      text: "Plan your outstation taxi today.",
      button: "Book Now",
      link: "/vehicle-selection"
    }
  },
  mumbaiPune: {
    path: "/mumbai-pune",
    seo: {
      title: "Mumbai to Pune Taxi | Fast and Safe Cab Booking",
      description:
        "Reserve Mumbai to Pune taxi rides with BookinIndia. Safe travel, clear fares, and professional drivers.",
      keywords: "mumbai to pune taxi, pune cab booking, outstation cab mumbai",
      canonicalUrl: "/mumbai-pune"
    },
    hero: {
      title: "Mumbai to Pune Taxi Service",
      subtitle: "Quick, reliable intercity cab bookings."
    },
    intro:
      "Book comfortable cabs from Mumbai to Pune with flexible pickup timing and trusted drivers.",
    sections: [
      {
        title: "Flexible Pickup Times",
        text:
          "Choose your preferred time for a stress-free journey."
      }
    ],
    cta: {
      title: "Book Mumbai -> Pune",
      text: "Reserve your outstation cab now.",
      button: "Book Now",
      link: "/vehicle-selection"
    }
  },
  bangaloreMysore: {
    path: "/bangalore-mysore",
    seo: {
      title: "Bangalore to Mysore Taxi | Outstation Cab Booking",
      description:
        "Book Bangalore to Mysore taxi services with BookinIndia. Comfortable cabs and professional drivers.",
      keywords: "bangalore to mysore taxi, mysore cab booking, outstation cab bangalore",
      canonicalUrl: "/bangalore-mysore"
    },
    hero: {
      title: "Bangalore to Mysore Taxi Service",
      subtitle: "Comfortable rides with transparent pricing."
    },
    intro:
      "Enjoy a smooth outstation trip from Bangalore to Mysore with reliable drivers and clean cars.",
    sections: [
      {
        title: "Comfort for Long Rides",
        text:
          "Spacious vehicles make intercity travel easy."
      }
    ],
    cta: {
      title: "Book Bangalore -> Mysore",
      text: "Start your outstation booking now.",
      button: "Book Now",
      link: "/vehicle-selection"
    }
  },
  chennaiPondy: {
    path: "/chennai-pondy",
    seo: {
      title: "Chennai to Pondicherry Taxi | Outstation Cabs",
      description:
        "Book Chennai to Pondicherry taxi services with BookinIndia. Safe, reliable, and comfortable rides.",
      keywords: "chennai to pondicherry taxi, pondy cab booking, outstation cab chennai",
      canonicalUrl: "/chennai-pondy"
    },
    hero: {
      title: "Chennai to Pondicherry Taxi Service",
      subtitle: "Safe and comfortable outstation travel."
    },
    intro:
      "Plan a smooth ride from Chennai to Pondicherry with verified drivers and transparent pricing.",
    sections: [
      {
        title: "One-Way or Round Trip",
        text:
          "Flexible packages to match your itinerary."
      }
    ],
    cta: {
      title: "Book Chennai -> Pondy",
      text: "Reserve your outstation cab today.",
      button: "Book Now",
      link: "/vehicle-selection"
    }
  },
  kolkataDigha: {
    path: "/kolkata-digha",
    seo: {
      title: "Kolkata to Digha Taxi | Outstation Cab Booking",
      description:
        "Book Kolkata to Digha taxi rides with BookinIndia. Comfortable cabs and trusted drivers.",
      keywords: "kolkata to digha taxi, digha cab booking, outstation cab kolkata",
      canonicalUrl: "/kolkata-digha"
    },
    hero: {
      title: "Kolkata to Digha Taxi Service",
      subtitle: "Comfortable intercity rides with clear pricing."
    },
    intro:
      "Travel from Kolkata to Digha with verified drivers and clean vehicles.",
    sections: [
      {
        title: "Trusted Outstation Service",
        text:
          "Professional drivers and reliable timing on every trip."
      }
    ],
    cta: {
      title: "Book Kolkata -> Digha",
      text: "Plan your outstation taxi today.",
      button: "Book Now",
      link: "/vehicle-selection"
    }
  },
  hyderabadVizag: {
    path: "/hyderabad-vizag",
    seo: {
      title: "Hyderabad to Vizag Taxi | Reliable Outstation Cabs",
      description:
        "Book Hyderabad to Vizag taxi services with BookinIndia. Safe rides, transparent fares, and clean vehicles.",
      keywords: "hyderabad to vizag taxi, vizag cab booking, outstation cab hyderabad",
      canonicalUrl: "/hyderabad-vizag"
    },
    hero: {
      title: "Hyderabad to Vizag Taxi Service",
      subtitle: "Professional drivers and comfortable cabs."
    },
    intro:
      "Enjoy outstation rides between Hyderabad and Vizag with predictable pricing and safe travel.",
    sections: [
      {
        title: "Comfortable Long-Distance Cabs",
        text:
          "Clean AC vehicles for relaxed travel."
      }
    ],
    cta: {
      title: "Book Hyderabad -> Vizag",
      text: "Secure your outstation cab today.",
      button: "Book Now",
      link: "/vehicle-selection"
    }
  },
  about: {
    path: "/about",
    seo: {
      title: "About BookinIndia | Trusted Taxi Service in Chennai",
      description:
        "Learn about BookinIndia, Chennai’s reliable taxi service for airport transfers, outstation rides, and local travel.",
      keywords: "about bookinindia, chennai taxi service, cab booking company",
      canonicalUrl: "/about"
    },
    hero: {
      title: "About BookinIndia",
      subtitle: "A trusted taxi platform built for safe and reliable travel."
    },
    intro:
      "BookinIndia connects riders with professional drivers and clean vehicles across Chennai and beyond.",
    sections: [
      {
        title: "Our Mission",
        text:
          "Make taxi booking simple, safe, and affordable for every traveler."
      },
      {
        title: "Our Commitment",
        text:
          "Verified drivers, transparent pricing, and responsive support."
      }
    ],
    cta: {
      title: "Ride with BookinIndia",
      text: "Experience reliable taxi service across Chennai.",
      button: "Book a Cab",
      link: "/vehicle-selection"
    }
  },
  careers: {
    path: "/careers",
    seo: {
      title: "Careers at BookinIndia | We’re Hiring",
      description:
        "Join BookinIndia and help build better taxi experiences in Chennai and across India.",
      keywords: "bookinindia careers, taxi company jobs, hiring chennai",
      canonicalUrl: "/careers"
    },
    hero: {
      title: "Careers at BookinIndia",
      subtitle: "Grow with a team that values safety, reliability, and impact."
    },
    intro:
      "We’re building the most trusted taxi service in India. If you love solving real travel problems, we’d love to meet you.",
    sections: [
      {
        title: "Why Join Us",
        text:
          "Mission-driven work, supportive team culture, and opportunities to learn."
      },
      {
        title: "We’re Hiring",
        text:
          "Send your resume and role interest to join our growing team."
      }
    ],
    cta: {
      title: "Apply Today",
      text: "Share your profile and we’ll get back quickly.",
      button: "Contact HR",
      link: "/contact"
    }
  },
  blog: {
    path: "/blog",
    seo: {
      title: "BookinIndia Blog | Travel Tips & Cab Updates",
      description:
        "Read travel tips, taxi updates, and Chennai ride insights from BookinIndia.",
      keywords: "bookinindia blog, travel tips, chennai taxi updates",
      canonicalUrl: "/blog"
    },
    hero: {
      title: "BookinIndia Blog",
      subtitle: "Insights, travel tips, and cab service updates."
    },
    intro:
      "Get helpful travel advice, route tips, and service announcements from the BookinIndia team.",
    sections: [
      {
        title: "Travel Tips",
        text:
          "Smart ways to plan airport trips, outstation rides, and local city travel."
      },
      {
        title: "Service Updates",
        text:
          "New features, service areas, and seasonal announcements."
      }
    ],
    cta: {
      title: "Stay Updated",
      text: "Follow BookinIndia for the latest travel tips.",
      button: "Contact Us",
      link: "/contact"
    }
  },
  press: {
    path: "/press",
    seo: {
      title: "Press Releases | BookinIndia",
      description:
        "Official press releases and announcements from BookinIndia.",
      keywords: "bookinindia press releases, company announcements",
      canonicalUrl: "/press"
    },
    hero: {
      title: "Press Releases",
      subtitle: "Official updates and announcements from BookinIndia."
    },
    intro:
      "Find official press releases, media updates, and company announcements.",
    sections: [
      {
        title: "Media Inquiries",
        text:
          "For press inquiries, contact our communications team."
      }
    ],
    cta: {
      title: "Press Contact",
      text: "Reach out for media and partnership inquiries.",
      button: "Contact Us",
      link: "/contact"
    }
  },
  investors: {
    path: "/investors",
    seo: {
      title: "Investor Relations | BookinIndia",
      description:
        "Investor relations information for BookinIndia, including company updates and growth initiatives.",
      keywords: "bookinindia investors, investor relations, company growth",
      canonicalUrl: "/investors"
    },
    hero: {
      title: "Investor Relations",
      subtitle: "Updates on BookinIndia’s growth and business outlook."
    },
    intro:
      "We are focused on building sustainable, reliable taxi services across India with strong local presence in Chennai.",
    sections: [
      {
        title: "Growth Focus",
        text:
          "Expanding service quality, customer trust, and regional coverage."
      }
    ],
    cta: {
      title: "Connect With Us",
      text: "Request investor information or updates.",
      button: "Contact Investor Relations",
      link: "/contact"
    }
  },
  sustainability: {
    path: "/sustainability",
    seo: {
      title: "Sustainability | BookinIndia",
      description:
        "Learn about BookinIndia’s sustainability efforts including cleaner vehicles and responsible travel practices.",
      keywords: "bookinindia sustainability, green travel, eco friendly taxi",
      canonicalUrl: "/sustainability"
    },
    hero: {
      title: "Sustainability at BookinIndia",
      subtitle: "Building a cleaner and more responsible travel ecosystem."
    },
    intro:
      "We support greener travel through cleaner vehicles, efficient routing, and responsible operations.",
    sections: [
      {
        title: "Cleaner Travel",
        text:
          "We encourage efficient routing and maintain cleaner fleet standards."
      },
      {
        title: "Community Impact",
        text:
          "Supporting local drivers and safe travel practices across India."
      }
    ],
    cta: {
      title: "Partner With Us",
      text: "Let’s build a sustainable travel future together.",
      button: "Reach Out",
      link: "/contact"
    }
  },
  help: {
    path: "/help",
    seo: {
      title: "Help Center | BookinIndia Support",
      description:
        "Get help with bookings, payments, and ride issues. BookinIndia support is here 24/7.",
      keywords: "bookinindia help center, taxi support, cab booking help",
      canonicalUrl: "/help"
    },
    hero: {
      title: "Help Center",
      subtitle: "Fast answers for booking, payments, and ride updates."
    },
    intro:
      "Find quick solutions or reach our support team anytime you need assistance.",
    sections: [
      {
        title: "Booking Help",
        text:
          "Modify, cancel, or reschedule your taxi bookings with ease."
      },
      {
        title: "Payment Support",
        text:
          "Get help with fare questions, receipts, or payment issues."
      }
    ],
    cta: {
      title: "Need Help Right Now?",
      text: "Contact our support team for immediate assistance.",
      button: "Contact Support",
      link: "/contact"
    }
  },
  cancellation: {
    path: "/cancellation",
    seo: {
      title: "Cancellation Policy | BookinIndia",
      description:
        "Read BookinIndia’s cancellation policy for taxi bookings, refunds, and rescheduling.",
      keywords: "cab cancellation policy, taxi refund policy, bookinindia support",
      canonicalUrl: "/cancellation"
    },
    hero: {
      title: "Cancellation Policy",
      subtitle: "Clear and fair policies for booking changes."
    },
    intro:
      "We keep cancellations simple and transparent. Review the policy below for timelines and charges.",
    sections: [
      {
        title: "Free Cancellation Window",
        text:
          "Cancel within the allowed window for a full refund, when applicable."
      },
      {
        title: "Rescheduling Options",
        text:
          "Change your pickup time or date with support assistance."
      }
    ],
    cta: {
      title: "Have a Question?",
      text: "Our team can help with cancellation or refund concerns.",
      button: "Contact Support",
      link: "/contact"
    }
  },
  feedback: {
    path: "/feedback",
    seo: {
      title: "Feedback | BookinIndia",
      description:
        "Share your feedback with BookinIndia and help us improve our taxi services.",
      keywords: "bookinindia feedback, taxi service feedback, cab review",
      canonicalUrl: "/feedback"
    },
    hero: {
      title: "We Value Your Feedback",
      subtitle: "Your suggestions help us improve every ride."
    },
    intro:
      "Tell us what went well and where we can do better. Your feedback matters.",
    sections: [
      {
        title: "Ride Experience",
        text:
          "Share your experience with drivers, vehicles, and support."
      }
    ],
    cta: {
      title: "Send Feedback",
      text: "Reach us quickly with your suggestions.",
      button: "Contact Us",
      link: "/contact"
    }
  },
  report: {
    path: "/report",
    seo: {
      title: "Report an Issue | BookinIndia Support",
      description:
        "Report ride issues, billing concerns, or safety complaints to BookinIndia support.",
      keywords: "report issue cab, taxi complaint, bookinindia support",
      canonicalUrl: "/report"
    },
    hero: {
      title: "Report an Issue",
      subtitle: "We take concerns seriously and respond quickly."
    },
    intro:
      "If you faced a problem during your ride, report it and we will resolve it fast.",
    sections: [
      {
        title: "Fast Resolution",
        text:
          "Our support team reviews issues promptly and follows up."
      }
    ],
    cta: {
      title: "Report a Concern",
      text: "Contact support to share your issue.",
      button: "Report Now",
      link: "/contact"
    }
  },
  contact: {
    path: "/contact",
    seo: {
      title: "Contact Us | BookinIndia",
      description:
        "Contact BookinIndia for bookings, support, corporate travel, or partnership inquiries.",
      keywords: "contact bookinindia, taxi booking support, cab service contact",
      canonicalUrl: "/contact"
    },
    hero: {
      title: "Contact BookinIndia",
      subtitle: "We’re here to help with bookings, support, and inquiries."
    },
    intro:
      "Reach out to our team for assistance with bookings, corporate travel, or service questions.",
    sections: [
      {
        title: "Customer Support",
        text:
          "Email or call us anytime for booking help or ride assistance."
      },
      {
        title: "Business Partnerships",
        text:
          "We support corporate travel and event transport in Chennai."
      }
    ],
    cta: {
      title: "Get in Touch",
      text: "We respond quickly to all inquiries.",
      button: "Send Message",
      link: "/contact-details"
    }
  }
};

export { STATIC_PAGES, popularRoutes };
